export const CIRCUIT_ANIMATION_DURATION: number = 1200;
